import { Component } from '@angular/core';

@Component({
    selector: 'app-admin-styleguide',
    templateUrl: './admin-styleguide.component.html',
    styleUrls: ['./admin-styleguide.component.scss'],
    standalone: false
})
export class AdminStyleguideComponent {}
